import React, { useEffect, useState, FC } from "react"
import { KInput, KSpan, KTitleSpan, KDropdown, KButton, KLogo, KTooltip } from "kahuna-base-react-components"
import TrackIsrcCodes from "../track-isrc-codes/TrackIsrcCodes"
import ReleaseUpcCodes from "../release-upc-codes/ReleaseUpcCodes"
import State51BatchIds from "../state-51-batch-ids/State51BatchIds"
import AdminUserAdvance from "./user-advance/AdminUserAdvance"
import AdminProfitAndLoss from "./profit-and-loss/AdminProfitAndLoss"
import { connect } from "react-redux"
import { RootState } from "../../../../store"
import { checkAdminPermission } from "../../../../utility"
import { ADMIN_PERMISSIONS } from "../../../../constants"

enum TabOptions {
  USER_ADVANCE = "User Advance",
  PROFIT_AND_LOSS = "P&L (Profit & Loss Overview)"
}

type AdminFinanceReportingProps = {
  userAdminPermissions?: string
}

const AdminFinanceReporting: FC<AdminFinanceReportingProps> = (props) => {
  const [openSidebar, setOpenSidebar] = useState<boolean>(true)
  const [selectedTab, setSelectedTab] = useState()

  return (
    <div className="catalog flex-grow justify-center">
      <div className="w-[100%] flex ">
        <div
          className={`${
            openSidebar ? "min-w-[230px]" : "min-w-0 !w-[0px]"
          } max-w-[320px] w-[20%] bg-[#F7F7F7] min-h-[100vh] flex flex-col overflow-hidden shrink-0`}
          style={{
            transitionDuration: "0.5s"
          }}
        >
          <div>
            <div className="py-1.5 px-4">
              <div className="p-2">
                <KTitleSpan text="Finance Reporting" color="#111" fontSize={20} lineHeight="28px" />
              </div>
              {checkAdminPermission(ADMIN_PERMISSIONS.FINANCE_REPORTING_USER_ADVANCE, props.userAdminPermissions) && (
                <div
                  data-testid="left-bar-upc"
                  className={`rounded-[10px] p-2 flex flex-row gap-2 mt-4 items-center ${
                    selectedTab === TabOptions.USER_ADVANCE ? "bg-[#FFF]" : "transparent"
                  } cursor-pointer whitespace-nowrap`}
                  onClick={() => {
                    if (selectedTab === TabOptions.USER_ADVANCE) return
                    setSelectedTab(TabOptions.USER_ADVANCE)
                  }}
                >
                  <KSpan text={"User Advance"} fontSize={12} lineHeight="20px" fontWeight={500} color="#111" />
                </div>
              )}

              {checkAdminPermission(ADMIN_PERMISSIONS.FINANCE_REPORTING_PL, props.userAdminPermissions) && (
                <div
                  data-testid="left-bar-isrc"
                  className={`rounded-[10px] p-2 flex flex-row gap-1 mt-1 items-center ${
                    selectedTab === TabOptions.PROFIT_AND_LOSS ? "bg-[#FFF]" : "transparent"
                  } cursor-pointer whitespace-nowrap`}
                  onClick={() => {
                    if (selectedTab === TabOptions.PROFIT_AND_LOSS) return
                    setSelectedTab(TabOptions.PROFIT_AND_LOSS)
                  }}
                >
                  <KSpan
                    text={"P&L (Profit & Loss Overview)"}
                    fontSize={12}
                    lineHeight="20px"
                    fontWeight={500}
                    color="#111"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="grow min-h-0">
          {selectedTab === TabOptions.USER_ADVANCE && (
            <AdminUserAdvance openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
          )}
          {selectedTab === TabOptions.PROFIT_AND_LOSS && (
            <AdminProfitAndLoss openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    userAdminPermissions: state.auth.user.adminPermissions
  }
}

export default connect(mapStateToProps, {})(AdminFinanceReporting)
